import { Culture } from '../../types';

export const cree: Culture = {
  name: 'Cree',
  languageFamily: 'Algic',
  terms: [
    {
      word: 'Kîsik',
      phonetic: 'kee-sik',
      description: 'Cree word for "sky."'
    },
    {
      word: 'Mîkisow',
      phonetic: 'mee-kee-soh',
      description: 'Cree term for "eagle."'
    },
    {
      word: 'Nipiy',
      phonetic: 'nee-pee',
      description: 'Cree word for "water."'
    },
    {
      word: 'Tânisi',
      phonetic: 'tah-nee-see',
      description: 'Cree greeting meaning "hello."'
    },
    {
      word: 'Wâwâ',
      phonetic: 'wah-wah',
      description: 'Cree term meaning "snow goose."'
    }
  ]
};